import {connect} from 'react-redux';
import {
storeDeviceToken
} from "actions/chatAction";
import PushNotification from "components/PushNotification";

const mapStateToProps = ({chat: {deviceToken}, auth: {isAuthenticated}, video: {callInProgress, room}}) => ({
  deviceToken,
  isAuthenticated,
  callInProgress,
  callRoom: room?.room,
});

export default connect(mapStateToProps, {storeDeviceToken})(PushNotification);
